import * as React from 'react';

import { RecommendationsService } from '../../Recommendations/ViewModels/RecommendationsService';
import { VisitorIntelligenceTrackerProps } from './VisitorIntelligenceTrackerProps.csharp';

export default class VisitorIntelligenceTracker extends React.Component<VisitorIntelligenceTrackerProps> {
    constructor(props: VisitorIntelligenceTrackerProps) {
        super(props);

        this.handlePageLoad = this.handlePageLoad.bind(this);
    }

    componentDidMount() {
        window.addEventListener('DOMContentLoaded', this.handlePageLoad);
    }

    componentWillUnmount() {
        this.removeContentLoadedEventListener();
    }

    private handlePageLoad() {
        this.removeContentLoadedEventListener();
        RecommendationsService.RefreshRecommendations(this.props.details);
    }

    private removeContentLoadedEventListener = () => {
        window.removeEventListener('DOMContentLoaded', this.handlePageLoad);
    };

    render() {
        return <></>;
    }
}
